import React from "react";
import { Link } from "react-router-dom";
import { MdLocationOn } from "react-icons/md";
import { motion } from "framer-motion";
import framerLogo from "../../assets/framer-motion.png";
import reactLogo from "../../assets/react-svgrepo-com.svg";
import cssLogo from "../../assets/css-svgrepo-com.svg";
import htmlLogo from "../../assets/html-svgrepo-com.svg";
import pbLogo from "../../assets/logo.svg";
function Main({ setShowModal, setTechType, setTechDescription }) {
  return (
    <>
      <main>
        <section className="home" id="home">
          <div className="about center ">
            <h1 className="about-name-intro">
              Hi, I'm <span className="about-name">Jordan Nelson.</span>
            </h1>
            <p className="about-me">
              I’m an aspiring Web Developer with experience mostly in full-stack
              development. This wesbite will document my journey to learn
              front-end technologies and my hunt for my dream job.
            </p>
            <h2 className="about-location">
              <span style={{ color: "#2978b5" }}>
                <MdLocationOn />
              </span>
              Melbourne
              <span style={{ marginLeft: "5px" }}>
                <img
                  src="https://em-content.zobj.net/thumbs/120/apple/325/flag-australia_1f1e6-1f1fa.png"
                  alt={"location pin"}
                />
              </span>
            </h2>
            <p className="about-me-melbourne">
              I’m currently located in Melbourne, Australia. There are loads of
              things that I love about here, particularly the coffee, culture
              and climate! Check out the{" "}
              <Link to="/pictures">
                <span style={{ color: "#2978b5" }}>
                  <a>pictures</a>
                </span>{" "}
              </Link>
              that I’ve taken in my time in Melbourne so far.
            </p>
            <h2 className="about-tech-used-heading">How the site is built</h2>
            <h2>Click an icon below to see what I use each for</h2>
            <ul className="tech-list">
              <motion.li
                className="tech-list-item"
                whileHover={{ scale: 1.2 }}
                onClick={() => {
                  setShowModal(true);
                  setTechType("Framer Motion");
                  setTechDescription(
                    "Framer Motion is a library for building animations in React."
                  );
                }}
              >
                <img
                  src={framerLogo}
                  style={{ width: "48px", height: "48px" }}
                  alt={"framer motion logo"}
                ></img>
              </motion.li>
              <motion.li
                className="tech-list-item"
                whileHover={{ scale: 1.2 }}
                onClick={() => {
                  setShowModal(true);
                  setTechType("React");
                  setTechDescription(
                    "React is a JavaScript library for building user interfaces."
                  );
                }}
              >
                <img
                  src={reactLogo}
                  style={{ width: "48px", height: "48px" }}
                  alt={"react logo"}
                ></img>
              </motion.li>
              <motion.li
                className="tech-list-item"
                whileHover={{ scale: 1.2 }}
                onClick={() => {
                  setShowModal(true);
                  setTechType("CSS");
                  setTechDescription(
                    "CSS is a language for describing the presentation of Web pages, including colors, layout, and fonts."
                  );
                }}
              >
                <img
                  src={cssLogo}
                  style={{ width: "48px", height: "48px" }}
                  alt={"css logo"}
                ></img>
              </motion.li>
              <motion.li
                className="tech-list-item"
                whileHover={{ scale: 1.2 }}
                onClick={() => {
                  setShowModal(true);
                  setTechType("HTML");
                  setTechDescription(
                    "HTML is the standard markup language for Web pages."
                  );
                }}
              >
                <img
                  src={htmlLogo}
                  style={{ width: "48px", height: "48px" }}
                  alt={"html logo"}
                ></img>
              </motion.li>
              <motion.li
                className="tech-list-item"
                whileHover={{ scale: 1.2 }}
                onClick={() => {
                  setShowModal(true);
                  setTechType("PocketBase");
                  setTechDescription(
                    "PocketBase is a database-as-a-service that allows you to create, store and retrieve data in a database."
                  );
                }}
              >
                <img
                  src={pbLogo}
                  style={{ width: "48px", height: "48px" }}
                  alt={"pocketbase logo"}
                ></img>
              </motion.li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default Main;
